// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"List_wrapper__aMHoY","placeholder":"List_placeholder__M5Ik9","placeholder-item":"List_placeholder-item__1VCbN","image-placeholder":"List_image-placeholder__15B_Y"};